import { render } from "./SocietyCard.vue?vue&type=template&id=61f0a9b4"
import script from "./SocietyCard.vue?vue&type=script&lang=js"
export * from "./SocietyCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__